import React from "react";
import { Row, Col, Progress } from "antd";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import middleware from "../../middleware";
import RightMenu from "../wea-right-menu/RightMenu";

class ProgressCom extends React.PureComponent {
  shouldComponentUpdate(nextProps, nextState, nextContext) {
    const { end, percent } = this.props;

    if (percent === nextProps.percent && end === nextProps.end) {
      return false;
    } else {
      return true;
    }
  }
  render() {
    const { end, percent } = this.props;
    return !end ? (
      <Progress
        percent={percent}
        showInfo={false}
        strokeWidth={2}
        status="active"
        ecId={`${this.props.ecId}_Progress@5g9x98`}
      />
    ) : null;
  }
}

class TitleColCom extends React.PureComponent {
  render() {
    const { icon, iconBgcolor, _breadcrumb, title } = this.props;
    return (
      <Col
        span="14"
        style={{ paddingLeft: 20, lineHeight: "50px" }}
        ecId={`${this.props.ecId}_Col@ffz3oe`}
      >
        <div className="wea-new-top-title wea-f14">
          {iconBgcolor ? (
            <div
              className="icon-circle-base"
              style={{ background: iconBgcolor || "" }}
            >
              {icon}
            </div>
          ) : (
            <span style={{ verticalAlign: "middle", marginRight: 10 }}>
              {icon}
            </span>
          )}
          <span
            className="wea-new-top-title-breadcrumb"
            style={{ verticalAlign: "middle" }}
            {...(_breadcrumb.length > 0 || typeof title !== "string"
              ? {}
              : { title })}
          >
            {_breadcrumb.length > 0 ? _breadcrumb : title}
          </span>
        </div>
      </Col>
    );
  }
}

class RightColCom extends React.PureComponent {
  render() {
    const {
      buttons,
      showDropIcon,
      menuProps,
      isDropMenuEmpty,
      showDrop,
      buttonSpace,
      handleShowDrop
    } = this.props;
    return (
      <Col
        span="10"
        style={{
          textAlign: "right",
          lineHeight: "50px",
          paddingRight: 14,
          position: "absolute",
          right: 0,
          top: 0,
          width: "auto"
        }}
        ecId={`${this.props.ecId}_Col@3ss8sy`}
      >
        {buttons.map(data => {
          return (
            <span
              style={{
                display: "inline-block",
                lineHeight: "28px",
                verticalAlign: "middle",
                marginLeft: !!buttonSpace ? buttonSpace : 10
              }}
            >
              {data}
            </span>
          );
        })}
        {showDropIcon && Object.keys(menuProps).length > 0 && (
          <span
            className={`wea-new-top-drop-btn ${isDropMenuEmpty &&
              "wea-new-top-drop-btn-displayNone"}`}
            onClick={() => handleShowDrop(true)}
            ecId={`${this.props.ecId}_span_dropIcon@w5r91g`}
          >
            <i className="icon-button icon-New-Flow-menu" />
          </span>
        )}
        <div
          className="wea-new-top-drop-menu wea-right-menu"
          onMouseLeave={() => handleShowDrop(false)}
          style={{ display: showDrop ? "block" : "none" }}
          ecId={`${this.props.ecId}_span_showDrop@fre939`}
        >
          <span
            className="wea-new-top-drop-btn"
            onClick={() => this.setState({ showDrop: false })}
            ecId={`${this.props.ecId}_span_dropBtn@dj5moj`}
          >
            <i className="icon-button icon-New-Flow-menu" />
          </span>
          {Object.keys(menuProps).length > 0 ? (
            <RightMenu
              {...menuProps}
              ref={el => (this.RightMenu = el)}
              ecId={`${this.props.ecId}_RightMenu@22c195`}
              showReport={true}
            />
          ) : null}
        </div>
      </Col>
    );
  }
}

class WeaTop extends React.Component {
  static displayName = "WeaTop";
  static defaultProps = {
    dropMenuDatas: undefined,
    dropMenuProps: {},
    icon: "",
    iconBgcolor: "",
    title: "",
    buttons: [],
    buttonSpace: 0,
    breadcrumb: [],
    className: "",
    style: {}
  };
  constructor(props) {
    super(props);
    this.instanceIsMounted = false;
    this.hash = `weatop_${Math.random()
      .toString(36)
      .substr(2, 6)}_${new Date().getTime()}`;
    this.state = {
      showDrop: false,
      percent: 85,
      end: true,
      height: 0,
      isDropMenuEmpty: false
    };
  }
  componentDidMount() {
    this.instanceIsMounted = true;
    this.scrollheigth();
    window.addEventListener("resize", this.onWindowResize);
    NProgress.configure({ showSpinner: false, minimum: 0.3, speed: 500 });
    this.props.onDidMount && this.props.onDidMount(this.props, this.hash);
    window.onTopDidMount && window.onTopDidMount(this.props, this.hash);
    if (this.RightMenu && this.RightMenu.isEmpty)
      this.setState({ isDropMenuEmpty: true });
  }
  componentWillReceiveProps(nextProps) {
    const { loading } = this.props;
    if (!loading && nextProps.loading) {
      NProgress.configure({ parent: `#${this.hash}` });
      NProgress.start(0.3);
      // this.timer = setInterval(() => {
      //   const percent = this.state.percent;
      //   const newP = percent < 96 ? (percent + 1) : 96;
      //   this.instanceIsMounted && this.setState({ end: false, percent: newP });
      // }, 10);
    } else if (loading && !nextProps.loading) {
      NProgress.done();
      // this.setState({ percent: 100 });
      // this.timer && clearInterval(this.timer);
      // setTimeout(() => {this.instanceIsMounted && this.setState({ percent: 85, end: true });}, 300);
    }
  }
  componentDidUpdate() {
    this.scrollheigth();
    const { isDropMenuEmpty } = this.state;
    const isdropmenuempty = this.RightMenu && this.RightMenu.isEmpty;
    if (isdropmenuempty !== isDropMenuEmpty)
      this.setState({ isDropMenuEmpty: isdropmenuempty });
  }
  componentWillUnmount() {
    // 防止节点卸载问题。。。
    window.removeEventListener("resize", this.onWindowResize);
    NProgress.configure({ parent: "body" });
    NProgress.done();
    NProgress.remove();
    this.instanceIsMounted = false;
  }
  onWindowResize = () => {
    this.instanceIsMounted && this.scrollheigth();
  };
  scrollheigth() {
    const { heightSpace, getHeight, inDialog = false } = this.props;
    const heightOther =
      heightSpace !== undefined ? heightSpace : inDialog ? 0 : 10;
    const content = this.refs.content;
    if (content) {
      const top = $(content).offset() ? $(content).offset().top : 0;
      const dialog = inDialog ? $(content).closest(".wea-dialog-body") : null;
      const scrollheigth =
        (inDialog && dialog
          ? dialog.height() + dialog.offset().top
          : document.documentElement.clientHeight) -
        top -
        heightOther;
      const { height } = this.state;
      if (height !== scrollheigth) {
        this.setState({ height: scrollheigth });
        typeof getHeight == "function" && getHeight(scrollheigth);
      }
    }
  }
  render() {
    const { showDrop, percent, end, height, isDropMenuEmpty } = this.state;
    const {
      children,
      icon,
      iconBgcolor,
      title,
      buttons,
      buttonSpace,
      isFixed,
      showDropIcon,
      dropMenuDatas,
      breadcrumb,
      dropMenuProps,
      onDropMenuClick,
      className,
      style
    } = this.props;
    const menuProps = { ...dropMenuProps };
    if (dropMenuProps.datas === undefined && Array.isArray(dropMenuDatas)) {
      menuProps.datas = dropMenuDatas;
    }
    if (typeof onDropMenuClick === "function") {
      menuProps.onClick = onDropMenuClick;
    }
    const _breadcrumb = [];
    breadcrumb.forEach((bc, index) => {
      index > 0 &&
        _breadcrumb.push(<i className="icon-coms-Browse-box-Add-to" />);
      _breadcrumb.push(
        <a className="wea-f14" {...bc}>
          {bc.name}
        </a>
      );
    });
    if (
      (!document.title || document.title === "undefined") &&
      typeof title === "string"
    ) {
      document.title = title;
    }
    const titleColComProps = { icon, iconBgcolor, _breadcrumb, title };
    const rightColComProps = {
      buttons,
      showDropIcon,
      menuProps,
      isDropMenuEmpty,
      showDrop,
      buttonSpace,
      handleShowDrop: v => this.setState({ showDrop: v })
    };
    return (
      <div
        className={`wea-new-top-wapper ${className}`}
        id={this.hash}
        style={style}
        ecId={`${this.props.ecId}_div@nrly0h`}
      >
        <Row
          className={!!isFixed ? "wea-new-top-fixed" : "wea-new-top"}
          ecId={`${this.props.ecId}_Row@di5qkc`}
        >
          <ProgressCom
            end={end}
            percent={percent}
            ecId={`${this.props.ecId}_ProgressCom@qx98a5`}
          />
          <TitleColCom
            {...titleColComProps}
            ecId={`${this.props.ecId}_TitleColCom@jkz6r1`}
          />
          <RightColCom
            {...rightColComProps}
            ecId={`${this.props.ecId}_RightColCom@a10dl7`}
          />
        </Row>
        {children && (
          <div ref="content" className="wea-new-top-content" style={{ height }}>
            {children}
          </div>
        )}
      </div>
    );
  }
}

const Com = middleware(WeaTop, "WeaTop");
export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-top/index.js